import { User } from "../../models/user/user";

export type HTTP_METHOD = "GET" | "POST" | "PUT" | "DELETE";

// 认证结果
export interface AuthResult {
  token: number;
  user: User;
}

// 登录参数
export interface LoginParams {
  username: string;
  password: string;
}

export interface ForgetPasswordParams {
  username: string
  email: string
}

export interface ResetPasswordParams {
  username: string
  password: string
  code: string
}

// 注册参数
export interface RegisterParams {
  name?: string;
  password: string;
  username?: string; // 登录名可以不用填写，服务端会自动生成
  phone?: string;
  email?: string;
  code?: string;
  country_code?: string;
  type?: number;
}

export interface PhoneCodeParams {
  token?: string
  country_code?: string
  phone: string
  code?: string
}

export interface UploadResult {
  uri: string;
  size: string;
  filename: string;
}

export interface UploadParams {
  formData: FormData;
  onProgressUpdate?: (n: number) => void;
}

export interface UploadClientResult {
  storage: string;
  url: string;
  payload?: any;
}

export interface UploadClientParams {
  filename: string;
  onProgressUpdate?: (n: number) => void;
}

export interface UploadToS3StorageResult {}

export type UploadToS3StorageParams = FormData;

export interface DownloadParams {
  url: string;
  onProgressUpdate?: (n: number) => void;
  method?: HTTP_METHOD;
}

export enum UpdateTypes {
  NO_UPDATE = -1,
  SOFT_UPDATE = 0,
  FORCE_UPDATE = 1,
}

type PlatformOSType = "ios" | "android";

export interface CheckVersionParams {
  version: string;
  device: PlatformOSType;
}

export interface CheckVersionResult {
  code: 0 | 1;
  data: {
    id: number;
    version: string;
    type: UpdateTypes;
    device: PlatformOSType;
    updated: string;
    created: string;
    description: string;
    install_url: string;
  };
}

// 登出参数
export interface LogoutParams {
  token: string;
}

// 登出参数
export interface LogoutResult {
  code: number;
}


export interface PingParams {
  token: string;
}

// 确认token是否有效结果
export interface PingResult {
  ip: string;
  message: string;
}

export interface RevisePasswordParams {
  old_pd: string;
  new_pd: string;
  confirm_new_pd: string;
  token: string;
}

export interface GetResult {
  code: number;
  data: any;
}

export interface GetParams {
  token: string;
  id?: string | number;
  params?: Record<string, string | number | boolean | any>;
  isSettled?: boolean;
}

export interface DeletePayParams {
  token: string;
  id: string;
}

export interface VerifyParams {
  token: string;
  real_name: string;
  id_number: string;
}

export interface PostResult {
  code: number;
  data?: any;
  message?: string;
}

export interface PhoneSmsParams {
  token: string;
  country_code: string;
  phone: string;
  code?: string;
}

export interface CreatePayPwdParams {
  token: string;
  pay_pwd: string;
  confirm: string;
  pay_pwd_secret_sign?: string;
}

export interface UpdatePayPwdParams {
  token: string;
  old_pay_pwd: string;
  new_pay_pwd: string;
}

export interface CreatePayParams {
  token?: string;
  real_name: string;
  pay_account: string;
  bank_name?: string;
  bank_branch?: string;
  file?: any;
  pay_type?: string | number;
}

export interface CheckPayParams {
  token: string;
  pay_pwd: string;
}

export interface CreateExchangeParams {
  token: string;
  usdt: string;
  usdt_rate: string;
}

export interface CancelExchangeParams {
  token: string;
  ex_order_no: string;
}

export interface SaveComplaintParams {
  token: string;
  usdt?: string;
  usdt_rate?: string;
  [key: string]: any;
}

export enum EvaluatePartyType {
  SELLER = 0,
  BUYER = 1,
}

export interface MyCreditParams {
  token?: string;
  page?: number;
  pageSize?: number;
  status?: EvaluatePartyType;
  [key: string]: any;
}

export interface SaveCreditParams {
  order_id?: string;
  star?: string | number;
  text?: string;
  photo?: any;
  [key: string]: any;
}

export interface EmailSmsParams {
  email: string;
}

export interface UpdateEmailParams {
  email: string;
  code: string;
}
